export const blogs = [
    {
        title: 'Demystifying Objects in JavaScript: A Comprehensive Guide',
        url: 'https://codescript.in/2024/03/15/demystifying-objects-in-javascript-a-comprehensive-guide',
        image: `https://codescript.in/wp-content/uploads/2024/03/JavaScript-Tutorial.jpg`
    },
    {
        title: 'How To Use Object Methods in JavaScript?',
        url: 'https://codescript.in/2024/03/15/how-to-use-object-methods-in-javascript/',
        image: `https://codescript.in/wp-content/uploads/2024/03/JavaScript-Tutorial.jpg`
    },
    {
        title: 'Deploying Spring Boot application on Amazon EC2 on AWS!',
        url: 'https://codescript.in/2023/07/28/deploying-spring-boot-application-on-amazon-ec2-on-aws/',
        image: `https://codescript.in/wp-content/uploads/2023/07/image-3.png`
    },
    {
        title: '20 Most Asked JavaScript Interview Questions & Answers',
        url: 'https://codescript.in/2024/02/02/20-most-asked-javascript-interview-questions-answers/',
        image: `https://codescript.in/wp-content/uploads/2024/02/interview.png`
    },
    {
        title: 'Optimizing Web Performance in Single-Page Applications with Heavy Dynamic Content',
        url: 'https://codescript.in/2023/08/20/optimizing-web-performance-in-single-page-applications-with-heavy-dynamic-content/',
        image: `https://codescript.in/wp-content/uploads/2023/08/Page-Speed-Optimization.png`
    },
    {
        title: 'How to upload an image from HTML to server through API?',
        url: 'https://codescript.in/2023/04/09/how-to-upload-an-image-from-html-to-server-through-api/',
        image: `https://codescript.in/wp-content/uploads/2023/04/image-1024x515.png`
    },
    {
        title: 'Responsive Images: Best Practices for Optimizing Web Performance',
        url: 'https://codescript.in/2023/08/17/responsive-images-best-practices-for-optimizing-web-performance/',
        image: `https://codescript.in/wp-content/uploads/2023/08/images.png`
    },
    {
        title: 'What are the software development process models?',
        url: 'https://codescript.in/2023/03/14/what-are-the-software-development-process-models/',
        image: `https://codescript.in/wp-content/uploads/2023/03/image-3.png`
    }
]